import React from "react";

// @mui component
import type { TableProps } from "@mui/material/Table";
import XTable from "@mui/material/Table";

const Table: React.FC<TableProps> = (props) => {
  return <XTable {...props}>{props.children}</XTable>;
};

export default Table;